export default __webpack_public_path__ + "static/media/know-aircraft-btn.17447366.png";